export const FEATURE_FLAGS = {
  PUBLIC_CATALOG: 'public_catalog',
} as const;
